import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { HeartHandshake, Sparkles, Activity, Globe2, Volume2, Triangle, Stethoscope, Users, QrCode, Copy, Phone, Mail, Building2, BookOpen, Hammer, Banknote, MapPin, MessageCircle, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import OrnamentalDivider from "../components/site/OrnamentalDivider";
import { ASSETS, GURUKULA } from "../lib/api";

const OBJECTIVES = [
    {
        Icon: Volume2,
        titleKn: "ನಾದಾನುಸಂಧಾನ ಮತ್ತು ಚಕ್ರ ಜಾಗೃತಿ",
        titleEn: "Sound Healing & Chakra Activation",
        whatKn:
            "ಮಾನವ ದೇಹದ ಸಪ್ತಚಕ್ರಗಳನ್ನು (Seven Chakras) ಸಂಗೀತದ ಸಪ್ತಸ್ವರಗಳ (ಸ, ರಿ, ಗ, ಮ, ಪ, ಧ, ನಿ) ಕಂಪನಗಳ ಮೂಲಕ ಜಾಗೃತಗೊಳಿಸುವುದು.",
        whatEn:
            "Awakening the body's seven chakras through the vibrations of the seven musical notes — Sa, Ri, Ga, Ma, Pa, Dha, Ni.",
        howKn:
            "ಪ್ರತಿಯೊಂದು ಚಕ್ರಕ್ಕೂ ಒಂದು ನಿರ್ದಿಷ್ಟ ಸ್ವರ ಮತ್ತು ರಾಗದ ಶಕ್ತಿ ಇರುತ್ತದೆ. ಪಿರಮಿಡ್‌ನ ಧ್ವನಿ ತರಂಗಗಳಿಂದ ಸಾಧಕರು ಆಳವಾದ ಧ್ಯಾನ ಸ್ಥಿತಿಗೆ ತಲುಪುತ್ತಾರೆ.",
        howEn:
            "Each chakra resonates with a specific swara and raga. The pyramid's acoustics carry sadhakas effortlessly into deep meditative states.",
    },
    {
        Icon: Triangle,
        titleKn: "ಪಿರಮಿಡ್ ಶಕ್ತಿಯ ಸದುಪಯೋಗ",
        titleEn: "Cosmic Energy Harvesting",
        whatKn:
            "ಪಿರಮಿಡ್ ವಿನ್ಯಾಸವು ಬ್ರಹ್ಮಾಂಡದ ಸಕಾರಾತ್ಮಕ ಶಕ್ತಿಯನ್ನು (Cosmic Energy) ತನ್ನ ಕೇಂದ್ರದಲ್ಲಿ ಹಿಡಿದಿಟ್ಟುಕೊಳ್ಳುತ್ತದೆ.",
        whatEn:
            "The pyramid geometry concentrates the universe's positive cosmic energy at its core.",
        howKn:
            "ಈ ಶಕ್ತಿಯುತ ಪರಿಸರದಲ್ಲಿ ಧ್ಯಾನ ಮಾಡುವುದರಿಂದ ಸಾಮಾನ್ಯ ಜಾಗಕ್ಕಿಂತ 3 ಪಟ್ಟು ವೇಗವಾಗಿ ಮನಸ್ಸು ಶಾಂತವಾಗುತ್ತದೆ ಮತ್ತು ಏಕಾಗ್ರತೆ ಸಿದ್ಧಿಸುತ್ತದೆ.",
        howEn:
            "Meditation inside this charged space calms the mind and sharpens focus up to three times faster than ordinary spaces.",
    },
    {
        Icon: Stethoscope,
        titleKn: "ಸಂಗೀತದ ಮೂಲಕ ರೋಗನಿವಾರಣೆ",
        titleEn: "Music Therapy",
        whatKn:
            "ಇಂದಿನ ಒತ್ತಡದ ಜೀವನಶೈಲಿಯಿಂದ ಉಂಟಾಗುವ ಮಾನಸಿಕ ಖಿನ್ನತೆ, ಆತಂಕ ಮತ್ತು ದೈಹಿಕ ಕಾಯಿಲೆಗಳಿಗೆ ಧ್ವನಿ ತರಂಗಗಳ ಮೂಲಕ ಚಿಕಿತ್ಸೆ ನೀಡುವುದು.",
        whatEn:
            "Treating modern stress, anxiety, depression, and ailments through music and sound vibrations.",
        howKn:
            "ಶಾಸ್ತ್ರೀಯ ಸಂಗೀತ, ಟಿಬೆಟನ್ ಬೌಲ್‌ಗಳು, ಓಂಕಾರ ಹಾಗೂ ಪ್ರಕೃತಿಯ ನಾದವನ್ನು ಬಳಸಿ ಮನಸ್ಸನ್ನು ಪ್ರಸನ್ನಗೊಳಿಸುವುದು.",
        howEn:
            "Classical ragas, Tibetan singing bowls, Omkara and nature sounds gently restore the mind to serenity.",
    },
    {
        Icon: Users,
        titleKn: "ವಿಶ್ವಬಂಧುತ್ವ ಮತ್ತು ಸಾಮೂಹಿಕ ಧ್ಯಾನ",
        titleEn: "Universal Brotherhood & Group Meditation",
        whatKn:
            "ಜಾತಿ, ಮತ, ಧರ್ಮಗಳ ಬೇಧವಿಲ್ಲದೆ ಎಲ್ಲರನ್ನೂ ಒಳಗೊಳ್ಳುವ 'ವಿಶ್ವ ಬಂಧು' ಕಲ್ಪನೆಯನ್ನು ಸಾಕಾರಗೊಳಿಸುವುದು.",
        whatEn:
            "Realising the ideal of Vishwa Bandhu — universal kinship that transcends caste, creed and faith.",
        howKn:
            "ಸಾಮೂಹಿಕ ನಾದಧ್ಯಾನದಿಂದ ಸೃಷ್ಟಿಯಾಗುವ ಸಕಾರಾತ್ಮಕ ತರಂಗಗಳು ವ್ಯಕ್ತಿಗಷ್ಟೇ ಅಲ್ಲದೆ ಸುತ್ತಮುತ್ತಲಿನ ಸಮಾಜಕ್ಕೂ ಶಾಂತಿಯನ್ನು ಹರಡುತ್ತವೆ.",
        howEn:
            "Collective nada-dhyana radiates positive vibrations that bring peace not only to the individual, but to the surrounding community.",
    },
];

const STEPS = [
    {
        n: "01",
        titleKn: "ಮೊದಲ ಹಂತ — ಪ್ರಾಣಾಯಾಮ",
        titleEn: "Stage One — Pranayama",
        kn: "ಪ್ರಾಣಾಯಾಮ ಮತ್ತು ಓಂಕಾರದ ಮೂಲಕ ದೇಹವನ್ನು ಸಡಿಲಗೊಳಿಸುವುದು.",
        en: "Releasing tension from the body through pranayama and Omkara chanting.",
    },
    {
        n: "02",
        titleKn: "ಎರಡನೇ ಹಂತ — ಸಪ್ತಸ್ವರ ಯಾತ್ರೆ",
        titleEn: "Stage Two — Saptaswara Journey",
        kn: "ಸಪ್ತಸ್ವರಗಳ ತರಂಗಗಳಿಗೆ ಅನುಗುಣವಾಗಿ ಮೂಲಾಧಾರದಿಂದ ಸಹಸ್ರಾರ ಚಕ್ರದವರೆಗೆ ಗಮನ ಹರಿಸುವುದು.",
        en: "Travelling attention from Muladhara to Sahasrara, in tune with the vibrations of the seven swaras.",
    },
    {
        n: "03",
        titleKn: "ಮೂರನೇ ಹಂತ — ಶೂನ್ಯ ಸ್ಥಿತಿ",
        titleEn: "Stage Three — Stillness",
        kn: "ಸಂಪೂರ್ಣ ಮೌನ — ಪಿರಮಿಡ್ ಶಕ್ತಿಯನ್ನು ದೇಹದೊಳಗೆ ಹೀರಿಕೊಳ್ಳುವುದು.",
        en: "Absolute silence — the body absorbs the pyramid's cosmic energy in pure stillness.",
    },
];

function Bilingual({ kn, en, knClass = "", enClass = "" }) {
    return (
        <div className="space-y-3">
            <p className={`text-kannada text-lg lg:text-xl text-maroon/95 leading-relaxed ${knClass}`}>
                {kn}
            </p>
            <p className={`font-serif text-lg lg:text-xl text-ink/85 leading-relaxed italic ${enClass}`}>
                {en}
            </p>
        </div>
    );
}

export default function Vision() {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const el = document.querySelector(location.hash);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [location.pathname, location.hash]);

    return (
        <div data-testid="vision-page" className="bg-ivory text-ink">
            <Navbar />

            {/* HERO */}
            <section className="relative overflow-hidden bg-cream" data-testid="vision-hero">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-12 lg:pt-24 lg:pb-16 text-center">
                    <div className="eyebrow">· Our Vision · ನಮ್ಮ ಕನಸಿನ ಯೋಜನೆ ·</div>
                    <h1 className="text-kannada font-semibold text-3xl sm:text-5xl lg:text-6xl text-maroon mt-6 leading-tight">
                        ಶ್ರೀ ವಿಶ್ವ ಬಂಧು ಪಿರಮಿಡ್ ನಾದಬ್ರಹ್ಮ ಮಂದಿರ
                    </h1>
                    <p className="text-kannada text-xl lg:text-2xl text-gold mt-3">
                        ಸಪ್ತಸ್ವರ ಚಕ್ರ ನಾದಾನುಸಂಧಾನ ಕೇಂದ್ರ
                    </p>
                    <p className="font-display italic text-2xl lg:text-3xl text-maroon/80 mt-6">
                        Shri Vishwa Bandhu Pyramid Nadabrahma Mandira
                    </p>
                    <p className="font-serif text-lg lg:text-xl text-ink/75 mt-2 max-w-3xl mx-auto">
                        A Saptaswara Chakra Nadanusandhana Kendra — a sacred research centre where
                        Music, Pyramid Science and Chakra wisdom converge.
                    </p>
                </div>
                <div className="max-w-6xl mx-auto px-6 lg:px-10 pb-20">
                    <div className="relative">
                        <div className="absolute -inset-3 border border-gold/40 pointer-events-none" />
                        <div className="absolute -inset-1 border border-gold/20 pointer-events-none" />
                        <img
                            src={ASSETS.visionDaytime}
                            alt="Concept rendering of the Shri Vishwa Bandhu Pyramid Nadabrahma Mandira"
                            data-testid="vision-concept-image"
                            className="relative w-full h-auto object-cover shadow-[0_40px_80px_-30px_rgba(90,17,31,0.5)]"
                        />
                        <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8 bg-gradient-to-t from-maroon-900/90 via-maroon-900/30 to-transparent text-ivory">
                            <div className="eyebrow text-gold-300">Concept Visualisation</div>
                            <div className="font-display italic text-xl lg:text-2xl mt-1">
                                A tanpura rising before the pyramid — where nada meets cosmos.
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* MAIN VISION */}
            <section className="section-pad bg-ivory" data-testid="vision-mission">
                <div className="max-w-5xl mx-auto px-6 lg:px-10 text-center">
                    <div className="eyebrow">· ೧ · ಮುಖ್ಯ ಧೇಯ · Vision & Mission ·</div>
                    <OrnamentalDivider className="mt-6" />
                    <p className="text-kannada text-2xl lg:text-3xl text-maroon mt-10 leading-snug font-semibold">
                        “ನಾದದ ಮೂಲಕ ಅಧ್ಯಾತ್ಮ, ಪಿರಮಿಡ್ ಮೂಲಕ ಶಕ್ತಿ, ಮತ್ತು ಧ್ಯಾನದ ಮೂಲಕ ಆತ್ಮಸಾಕ್ಷಾತ್ಕಾರ.”
                    </p>
                    <p className="font-display italic text-xl lg:text-2xl text-gold mt-5">
                        “Spirituality through Nada, energy through the Pyramid, and Self-realisation
                        through meditation.”
                    </p>

                    <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8 text-left">
                        <div className="card-cream p-8">
                            <div className="eyebrow text-gold">ಕನ್ನಡ</div>
                            <p className="text-kannada text-lg text-ink/90 mt-3 leading-relaxed">
                                ಬ್ರಹ್ಮಾಂಡದ ಪರಮ ಶಕ್ತಿಯಾದ ನಾದಬ್ರಹ್ಮ ಹಾಗೂ ಪಿರಮಿಡ್‌ನ ಕಾಸ್ಮಿಕ್ ಶಕ್ತಿಯನ್ನು
                                ಸಂಯೋಜಿಸಿ, ಮಾನವನ ದೈಹಿಕ, ಮಾನಸಿಕ ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಉನ್ನತಿಗೆ ಒಂದು
                                ಪವಿತ್ರ ವೇದಿಕೆಯನ್ನು ಕಲ್ಪಿಸುವುದು ಈ ಮಂದಿರದ ಮುಖ್ಯ ಧೇಯವಾಗಿದೆ.
                            </p>
                        </div>
                        <div className="p-8 bg-maroon text-ivory">
                            <div className="eyebrow text-gold-300">English</div>
                            <p className="font-serif text-lg text-ivory/95 mt-3 leading-relaxed">
                                By uniting Nadabrahma — the supreme cosmic vibration — with the
                                cosmic energy of the Pyramid, this Mandira seeks to offer humanity
                                a sacred platform for physical, mental and spiritual upliftment.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* KEY OBJECTIVES */}
            <section className="section-pad bg-cream" data-testid="vision-objectives">
                <div className="max-w-7xl mx-auto px-6 lg:px-10">
                    <div className="text-center mb-14">
                        <div className="eyebrow">· ೨ · ಪ್ರಮುಖ ಉದ್ದೇಶಗಳು · Key Objectives ·</div>
                        <h2 className="font-display text-4xl sm:text-5xl text-maroon mt-4 leading-tight">
                            Four pillars of the
                            <span className="italic text-gold"> Nadabrahma Mandira.</span>
                        </h2>
                        <p className="text-kannada text-lg text-ink/80 mt-4 max-w-3xl mx-auto leading-relaxed">
                            ನಮ್ಮ ಪಿರಮಿಡ್ ಸಪ್ತಸ್ವರ ಚಕ್ರ ಧ್ಯಾನ ಮಂದಿರ ಯಾವ ಉದ್ದೇಶಗಳಿಗಾಗಿ
                            ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ ಎಂಬುದರ ವಿವರಣೆ.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-7">
                        {OBJECTIVES.map((o, i) => {
                            const Icon = o.Icon;
                            return (
                                <div
                                    key={o.titleEn}
                                    data-testid={`objective-${i}`}
                                    className="card-cream p-8"
                                >
                                    <div className="flex items-center justify-between mb-5">
                                        <div className="w-12 h-12 flex items-center justify-center bg-maroon text-gold-300">
                                            <Icon size={20} />
                                        </div>
                                        <span className="font-display italic text-gold text-3xl">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                    </div>
                                    <h3 className="text-kannada text-2xl text-maroon leading-tight font-semibold">
                                        {o.titleKn}
                                    </h3>
                                    <p className="font-display italic text-2xl text-gold mt-1">
                                        {o.titleEn}
                                    </p>

                                    <div className="mt-6 space-y-5">
                                        <div>
                                            <div className="eyebrow text-ink/60">ಏನು? · What</div>
                                            <Bilingual kn={o.whatKn} en={o.whatEn} />
                                        </div>
                                        <div>
                                            <div className="eyebrow text-ink/60">ಹೇಗೆ? · How</div>
                                            <Bilingual kn={o.howKn} en={o.howEn} />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* HOW IT WORKS */}
            <section className="section-pad bg-maroon-900 text-ivory" data-testid="vision-howitworks">
                <div className="max-w-7xl mx-auto px-6 lg:px-10">
                    <div className="text-center mb-14">
                        <div className="eyebrow text-gold-300">· ೩ · ಇದು ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ · How It Works ·</div>
                        <h2 className="font-display text-4xl sm:text-5xl text-ivory mt-4 leading-tight">
                            The architecture of
                            <span className="italic text-gold-300"> inner experience.</span>
                        </h2>
                    </div>

                    <div className="bg-maroon p-8 lg:p-10 mb-12 border border-gold/30">
                        <div className="eyebrow text-gold-300 mb-3">· ವಿಶೇಷ ಪಿರಮಿಡ್ ವಿನ್ಯಾಸ · Pyramid Design ·</div>
                        <p className="text-kannada text-lg text-ivory/95 leading-relaxed">
                            ಪಿರಮಿಡ್‌ನ ಕೋನಗಳನ್ನು (೫೧° ೫೧′ — ಗೀಜಾ ಪಿರಮಿಡ್ ಶೈಲಿ) ಕರಾರುವಾಕ್ಕಾಗಿ
                            ನಿರ್ಮಿಸಲಾಗುತ್ತದೆ. ಒಳಗಿನ ಧ್ವನಿ ವ್ಯವಸ್ಥೆ ಎಷ್ಟು ಸೂಕ್ಷ್ಮವೆಂದರೆ, ಉಸಿರಾಟದ
                            ಸದ್ದೂ ಧ್ಯಾನಕ್ಕೆ ಪೂರಕವಾಗಿ ಕೇಳಿಸುತ್ತದೆ.
                        </p>
                        <p className="font-serif italic text-ivory/80 mt-3 leading-relaxed text-lg lg:text-xl">
                            The pyramid's angles (51° 51′ — Giza geometry) are crafted with absolute
                            precision. The acoustics within are so refined that even the sound of one's
                            own breath aids the meditation.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {STEPS.map((s) => (
                            <div
                                key={s.n}
                                className="border border-gold/30 bg-maroon/40 p-7"
                                data-testid={`step-${s.n}`}
                            >
                                <div className="font-display italic text-gold-300 text-5xl">{s.n}</div>
                                <h3 className="text-kannada text-xl text-ivory mt-3 font-semibold leading-tight">
                                    {s.titleKn}
                                </h3>
                                <p className="font-display italic text-xl text-gold-300 mt-1">
                                    {s.titleEn}
                                </p>
                                <p className="text-kannada text-lg text-ivory/90 mt-5 leading-relaxed">
                                    {s.kn}
                                </p>
                                <p className="font-serif italic text-ivory/85 text-lg mt-3 leading-relaxed">
                                    {s.en}
                                </p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-14 text-center max-w-3xl mx-auto">
                        <OrnamentalDivider className="mb-8 opacity-70" />
                        <p className="text-kannada text-xl text-ivory leading-relaxed">
                            ನಿಯಮಿತವಾಗಿ ಸಂಗೀತಜ್ಞರು ಮತ್ತು ಆಧ್ಯಾತ್ಮಿಕ ಗುರುಗಳಿಂದ
                            <strong className="text-gold-300"> “ನಾದಯೋಗ”</strong> ಮತ್ತು
                            <strong className="text-gold-300"> “ಚಕ್ರ ಶುದ್ಧಿ”</strong> ಶಿಬಿರಗಳನ್ನು
                            ಆಯೋಜಿಸಲಾಗುತ್ತದೆ.
                        </p>
                        <p className="font-serif italic text-ivory/80 mt-3 leading-relaxed text-lg lg:text-xl">
                            Regular Nadayoga and Chakra Shuddhi camps will be conducted by leading
                            musicians and spiritual masters.
                        </p>
                    </div>
                </div>
            </section>

            {/* ARCHITECTURE & SACRED SPACES */}
            <section
                className="section-pad bg-cream"
                data-testid="vision-architecture"
            >
                <div className="max-w-7xl mx-auto px-6 lg:px-10">
                    <div className="text-center mb-14">
                        <div className="eyebrow">· ಮಂದಿರದ ರಚನೆ · Architecture & Sacred Spaces ·</div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-maroon mt-4 leading-tight">
                            A pyramid of
                            <span className="italic text-gold"> four sacred floors.</span>
                        </h2>
                        <p className="text-kannada text-lg lg:text-xl text-ink/85 mt-5 max-w-3xl mx-auto leading-relaxed">
                            ಶ್ರೀ ವಿಶ್ವಬಂಧು ಪಿರಮಿಡ್ ನಾದಬ್ರಹ್ಮ ಮಂದಿರ — ಸಂಗೀತ, ಧ್ಯಾನ ಮತ್ತು
                            ಆತ್ಮ ಸಾಕ್ಷಾತ್ಕಾರಕ್ಕೆ ಮೀಸಲಾದ ನಾಲ್ಕು ಪವಿತ್ರ ಚೋಣಗಳ ಪಿರಮಿಡ್.
                        </p>
                        <p className="font-serif italic text-lg lg:text-xl text-ink/80 mt-3 max-w-3xl mx-auto leading-relaxed">
                            The Shri Vishwabandhu Pyramid Nadabrahma Mandira — a pyramid of four
                            sacred floors dedicated to music, meditation and self-realisation.
                        </p>
                    </div>

                    {/* Cutaway architectural drawing */}
                    <div className="relative mb-16" data-testid="architecture-cutaway">
                        <div className="absolute -inset-3 border border-gold/40 pointer-events-none" />
                        <div className="absolute -inset-1 border border-gold/20 pointer-events-none" />
                        <img
                            src={ASSETS.visionCutaway}
                            alt="Cross-section of Shri Vishwabandhu Pyramid Nadabrahma Mandira showing four floors — Ground, First, Second and Third"
                            className="relative w-full h-auto object-cover shadow-[0_40px_80px_-30px_rgba(90,17,31,0.5)]"
                        />
                    </div>

                    {/* Four floors — bilingual cards */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {[
                            {
                                floor: "GROUND FLOOR",
                                floorKn: "ಗ್ರೌಂಡ್ ಫ್ಲೋರ್",
                                titleKn: "ಪ್ರವೇಶ ಮಂಟಪ ಮತ್ತು ಉದ್ಯಾನ",
                                titleEn: "Entrance Mantapa & Sacred Garden",
                                kn: "ಪ್ರವೇಶದ್ವಾರದಿಂದ ಪವಿತ್ರವಾದ ಉದ್ಯಾನವನ — ಮುಂಜಾವಿನ ಧ್ಯಾನ, ಸಂಧ್ಯಾ ಸಂಗೀತ ಮತ್ತು ನಾದ-ಸಭೆಗಳಿಗೆ ತೆರೆದ ಆವರಣ.",
                                en: "An open precinct of meditative pathways, lotus pools and lantern-lit groves — for dawn meditation, evening music and gatherings of the sangha.",
                            },
                            {
                                floor: "FIRST FLOOR",
                                floorKn: "೧ನೇ ಚೋಣ",
                                titleKn: "ಸರಸ್ವತಿ ಧ್ಯಾನ ಮಂದಿರ (ಸಭಾಂಗಣ)",
                                titleEn: "Saraswati Dhyana Mandira · Sabhangana",
                                kn: "ವಿಶಾಲ ಧ್ಯಾನ ಮಂದಿರ, ಸಂಗೀತ ಕಚೇರಿ, ಉತ್ಸವಗಳಿಗೆ ಹಾಗೂ ಸಾಂಸ್ಕೃತಿಕ ಕಾರ್ಯಕ್ರಮಗಳಿಗೆ ಮೀಸಲಾದ ಪವಿತ್ರ ಸಭಾಂಗಣ.",
                                en: "A grand sabhangana for meditation, classical concerts, raga vidwath sammelanas and cultural performances — at the feet of Devi Saraswati.",
                            },
                            {
                                floor: "SECOND FLOOR",
                                floorKn: "೨ನೇ ಚೋಣ",
                                titleKn: "ಸಂಗೀತ ಕಲಿಶಾ ಕೊಠಡಿಗಳು",
                                titleEn: "Music Learning Rooms",
                                kn: "ವಿವಿಧ ಸಂಗೀತ ಶಾಸ್ತ್ರ, ವಾದ್ಯ, ಗಾನ ಮತ್ತು ಲಯ ತರಬೇತಿಗಾಗಿ ಸುಸಜ್ಜಿತಪಾದ ಪವಿತ್ರ ಕೊಠಡಿಗಳು.",
                                en: "Acoustically tuned classrooms dedicated to vocal training, instrumental study, sangeeta shastra and rhythm — the heart of the Guru-Shishya parampara.",
                            },
                            {
                                floor: "THIRD FLOOR",
                                floorKn: "೩ನೇ ಚೋಣ",
                                titleKn: "ಆತ್ಮ ಸಾಕ್ಷಾತ್ಕಾರ ಮಂದಿರ",
                                titleEn: "Atma Sakshatkara Mandira",
                                kn: "ಪಿರಮಿಡ್‌ನ ತುದಿಯಲ್ಲಿ ಸ್ಫಟಿಕದ ಆತ್ಮಲಿಂಗ — ಮೇಲಿನ ಸ್ಫಟಿಕದಿಂದ ಬಂದ ಬೆಳಕು ಲಿಂಗದ ಮೇಲೆ ಪ್ರತಿಫಲಿಸುತ್ತದೆ. ಶುದ್ಧ ಆತ್ಮ-ಸಾಕ್ಷಾತ್ಕಾರಕ್ಕೆ ಎಡೆಮಾಡಿಕೊಡುವ ಅಪೂರ್ವ ಸ್ಥಳ.",
                                en: "At the pyramid's apex sits the crystal atma-linga. A shaft of light through the crown crystal falls precisely upon it — a chamber crafted for the singular experience of self-realisation.",
                            },
                        ].map((f, i) => (
                            <div
                                key={f.floor}
                                data-testid={`architecture-floor-${i}`}
                                className="card-cream p-7 flex flex-col"
                            >
                                <div className="flex items-center justify-between mb-4">
                                    <div className="eyebrow text-gold">{f.floor}</div>
                                    <span className="text-kannada text-base text-maroon/80">{f.floorKn}</span>
                                </div>
                                <h3 className="text-kannada text-2xl text-maroon font-semibold leading-tight">
                                    {f.titleKn}
                                </h3>
                                <p className="font-display italic text-2xl text-gold mt-1 leading-snug">
                                    {f.titleEn}
                                </p>
                                <p className="text-kannada text-lg text-ink/90 mt-5 leading-relaxed">
                                    {f.kn}
                                </p>
                                <p className="font-serif italic text-lg text-ink/85 mt-3 leading-relaxed">
                                    {f.en}
                                </p>
                            </div>
                        ))}
                    </div>

                    {/* Two ancillary spaces */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                        <div className="bg-maroon text-ivory p-7 border border-gold/30">
                            <div className="eyebrow text-gold-300">ಮ್ಯೂಸಿಕ್ ಥೆರಪಿ ಕೇಂದ್ರ · Music Therapy Centre</div>
                            <p className="text-kannada text-lg text-ivory/95 mt-3 leading-relaxed">
                                ಧ್ವನಿ ತರಂಗಗಳು, ಟಿಬೆಟನ್ ಬೌಲ್ ಮತ್ತು ಶಾಸ್ತ್ರೀಯ ಸಂಗೀತದ ಮೂಲಕ ಮಾನಸಿಕ ಮತ್ತು ದೈಹಿಕ ಚಿಕಿತ್ಸೆ.
                            </p>
                            <p className="font-serif italic text-lg text-ivory/85 mt-3 leading-relaxed">
                                A dedicated therapy chamber where sound vibrations, Tibetan bowls
                                and ragas restore mental and physical well-being.
                            </p>
                        </div>
                        <div className="bg-maroon text-ivory p-7 border border-gold/30">
                            <div className="eyebrow text-gold-300">ಸಂಗೀತ ಗ್ರಂಥಾಲಯ · Music Library</div>
                            <p className="text-kannada text-lg text-ivory/95 mt-3 leading-relaxed">
                                ಶಾಸ್ತ್ರೀಯ ಗ್ರಂಥಗಳು, ತಾಳಪತ್ರಗಳು, ಧ್ವನಿಮುದ್ರಣಗಳು ಮತ್ತು ರಾಗ-ಸಾಹಿತ್ಯದ ಸಂಗ್ರಹ.
                            </p>
                            <p className="font-serif italic text-lg text-ivory/85 mt-3 leading-relaxed">
                                A living archive of classical treatises, palm-leaf manuscripts,
                                rare audio recordings and raga-sahitya from across India.
                            </p>
                        </div>
                    </div>

                    {/* Ambient renders gallery */}
                    <div className="mt-14">
                        <div className="text-center mb-10">
                            <div className="eyebrow">· ಪರಿಸರ ದೃಶ್ಯಗಳು · Concept Renders ·</div>
                            <h3 className="font-display text-3xl sm:text-4xl text-maroon mt-3 leading-tight">
                                From dawn light to
                                <span className="italic text-gold"> moonlit silence.</span>
                            </h3>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                            <figure className="lg:col-span-7 relative group overflow-hidden border border-gold/40">
                                <img
                                    src={ASSETS.visionDaytime}
                                    alt="Daytime view of the pyramid with Saraswati, lotus mandala and forest"
                                    data-testid="render-daytime"
                                    className="w-full h-[420px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                                />
                                <figcaption className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-maroon-900/95 via-maroon-900/40 to-transparent text-ivory">
                                    <div className="eyebrow text-gold-300">· ಸವಿಯಾದ ಬೆಳಗು · Morning Vibhāva ·</div>
                                    <div className="font-display italic text-xl mt-1">
                                        Sunlight, mountain breeze, and the first sruti of the day.
                                    </div>
                                </figcaption>
                            </figure>

                            <figure className="lg:col-span-5 relative group overflow-hidden border border-gold/40">
                                <img
                                    src={ASSETS.visionNight}
                                    alt="Pyramid Nadabrahma Mandira at night under the full moon, surrounded by lanterns and meditation cushions"
                                    data-testid="render-night"
                                    className="w-full h-[420px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                                />
                                <figcaption className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-maroon-900/95 via-maroon-900/40 to-transparent text-ivory">
                                    <div className="eyebrow text-gold-300">· ಚಂದ್ರೋದಯ · Moonlit Meditation ·</div>
                                    <div className="font-display italic text-xl mt-1">
                                        Under the full moon — the chamber listens, and silence sings.
                                    </div>
                                </figcaption>
                            </figure>

                            <figure className="lg:col-span-5 relative group overflow-hidden border border-gold/40">
                                <img
                                    src={ASSETS.visionGardenWalk}
                                    alt="Stone pathway through the sacred garden alongside carved walls of the pyramid"
                                    data-testid="render-garden"
                                    className="w-full h-[420px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                                />
                                <figcaption className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-maroon-900/95 via-maroon-900/40 to-transparent text-ivory">
                                    <div className="eyebrow text-gold-300">· ಪವಿತ್ರ ಮಾರ್ಗ · The Sacred Path ·</div>
                                    <div className="font-display italic text-xl mt-1">
                                        Every step toward the Mandira is itself a meditation.
                                    </div>
                                </figcaption>
                            </figure>

                            <figure className="lg:col-span-7 relative group overflow-hidden border border-gold/40">
                                <img
                                    src={ASSETS.visionInterior}
                                    alt="Interior of the pyramid with crystal apex casting a beam of light on the atma-linga"
                                    data-testid="render-interior"
                                    className="w-full h-[420px] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                                />
                                <figcaption className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-maroon-900/95 via-maroon-900/40 to-transparent text-ivory">
                                    <div className="eyebrow text-gold-300">· ಆತ್ಮಲಿಂಗ · Inside the Sanctum ·</div>
                                    <div className="font-display italic text-xl mt-1">
                                        The crystal apex bends a single ray onto the atma-linga.
                                    </div>
                                </figcaption>
                            </figure>
                        </div>
                    </div>

                    <OrnamentalDivider className="mt-16" />
                </div>
            </section>
            <section className="section-pad bg-ivory" data-testid="vision-appeal">
                <div className="max-w-5xl mx-auto px-6 lg:px-10">
                    <div className="text-center">
                        <div className="eyebrow">· ನಮ್ಮೊಂದಿಗೆ ಕೈಜೋಡಿಸಿ · Join Us ·</div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-maroon mt-4 leading-tight">
                            From Nada to
                            <span className="italic text-gold"> the Divine.</span>
                        </h2>
                        <p className="text-kannada text-xl text-maroon/90 mt-4">
                            ನಾದದಿಂ ಅಧ್ಯಾತ್ಮದತ್ತ — ನಮ್ಮ ಕನಸಿನ ಯೋಜನೆ
                        </p>
                    </div>

                    <div className="mt-14 space-y-10">
                        <div className="border-l-2 border-gold pl-6 lg:pl-8">
                            <p className="text-kannada text-lg lg:text-xl text-ink/90 leading-relaxed">
                                ಆತ್ಮೀಯ ಸಂಗೀತ ಹಾಗೂ ಆಧ್ಯಾತ್ಮಿಕ ಬಂಧುಗಳೇ,
                            </p>
                            <p className="text-kannada text-base lg:text-lg text-ink/85 leading-relaxed mt-4">
                                ನಮ್ಮ ಶ್ರೀ ವಿಶ್ವ ಬಂಧು ಸಂಗೀತ ಗುರುಕುಲವು ಕೇವಲ ಸಂಗೀತವನ್ನು ಕಲಿಸುವ
                                ಸಂಸ್ಥೆಯಾಗಿ ಉಳಿಯದೆ, ಸಂಗೀತದ ಮೂಲಕ ಮಾನವನ ಒಳಚೇತನವನ್ನು
                                ಜಾಗೃತಗೊಳಿಸುವ ಮಹತ್ತರ ಉದ್ದೇಶವನ್ನು ಹೊಂದಿದೆ. ನಾದ ಮತ್ತು ಅಧ್ಯಾತ್ಮ
                                ಒಂದೇ ನಾಣ್ಯದ ಎರಡು ಮುಖಗಳು. ಈ ನಾದಯೋಗವನ್ನು ಪ್ರತಿಯೊಬ್ಬರಿಗೂ
                                ತಲುಪಿಸಲು ನಾವು ಒಂದು ವಿಶಿಷ್ಟ ಯೋಜನೆಯನ್ನು ಕೈಗೆತ್ತಿಕೊಂಡಿದ್ದೇವೆ —
                                <strong> ಶ್ರೀ ವಿಶ್ವ ಬಂಧು ಪಿರಮಿಡ್ ನಾದಬ್ರಹ್ಮ ಮಂದಿರ.</strong>
                            </p>
                            <p className="font-serif italic text-ink/70 text-base lg:text-lg mt-5 leading-relaxed">
                                Dear friends in music and spirit — our Gurukula is not merely an
                                institution that teaches music. It carries a higher purpose: to awaken
                                the inner consciousness of every human being through Nada. Music
                                and spirituality are two sides of the same coin. To bring this
                                Nadayoga within reach of all, we have undertaken a singular project —
                                the <em>Shri Vishwa Bandhu Pyramid Nadabrahma Mandira.</em>
                            </p>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            <div className="card-cream p-8">
                                <div className="eyebrow text-gold mb-3">· ಯೋಜನೆಯ ಮಹತ್ವ · Significance ·</div>
                                <p className="text-kannada text-base text-ink/85 leading-relaxed">
                                    ಬ್ರಹ್ಮಾಂಡದ ಸಕಾರಾತ್ಮಕ ಶಕ್ತಿಯನ್ನು ಸೆಳೆಯುವ ಪಿರಮಿಡ್ ವಿಜ್ಞಾನ
                                    ಮತ್ತು ಶಾಸ್ತ್ರೀಯ ಸಂಗೀತದ ಸಪ್ತಸ್ವರಗಳ ಕಂಪನಗಳನ್ನು ಸಂಯೋಜಿಸಿ
                                    ಸಪ್ತಚಕ್ರಗಳನ್ನು ಶುದ್ಧೀಕರಿಸಿ ಆಳವಾದ ಮಾನಸಿಕ ಶಾಂತಿ ಹಾಗೂ
                                    ರೋಗನಿವಾರಣೆಯನ್ನು ಕಲ್ಪಿಸುವುದು ಇದರ ಮುಖ್ಯ ಉದ್ದೇಶ.
                                </p>
                                <p className="font-serif italic text-base lg:text-lg text-ink/85 mt-4 leading-relaxed">
                                    The Mandira will fuse Pyramid science — which draws cosmic
                                    positivity — with the vibrations of the seven swaras of Indian
                                    classical music, to purify the seven chakras and offer deep
                                    mental peace and music therapy.
                                </p>
                            </div>

                            <div className="p-8 bg-maroon text-ivory">
                                <div className="eyebrow text-gold-300 mb-3">· ಸಮಾನಮನಸ್ಕರ ಸಹಯೋಗ · A Call for Collaboration ·</div>
                                <p className="text-kannada text-base text-ivory/95 leading-relaxed">
                                    ಇಂತಹ ಆಧ್ಯಾತ್ಮಿಕ ಸಂಶೋಧನಾ ಕೇಂದ್ರದ ನಿರ್ಮಾಣಕ್ಕೆ ಅಪಾರ ಶ್ರಮ
                                    ಮತ್ತು ಸಂಪನ್ಮೂಲಗಳ ಅಗತ್ಯವಿದೆ. ಕೇವಲ ಹಣಕಾಸಿನ ನೆರವಿಗಿಂತ ಹೆಚ್ಚಾಗಿ,
                                    ಕಲೆ, ಸಂಗೀತ ಮತ್ತು ಅಧ್ಯಾತ್ಮದ ಮೇಲೆ ನಂಬಿಕೆಯಿಟ್ಟಿರುವ
                                    ಸಮಾನಮನಸ್ಕರ ಸಹಯೋಗ ನಮಗೆ ಬೇಕಾಗಿದೆ.
                                </p>
                                <p className="font-serif italic text-base lg:text-lg text-ivory/85 mt-4 leading-relaxed">
                                    Building such a spiritual research centre demands immense effort
                                    and resources. More than financial support, we seek the
                                    collaboration of kindred souls who believe in art, music and
                                    the path of the spirit.
                                </p>
                            </div>
                        </div>

                        <div className="text-center bg-cream border border-gold-100 p-10 lg:p-14">
                            <OrnamentalDivider className="mb-8" />
                            <p className="text-kannada text-2xl lg:text-3xl text-maroon font-semibold leading-snug">
                                “ಯಜ್ಞ ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿ ಸಮಿಧೆಯನ್ನು ಹಾಕುವಂತೆ, ಸಮಾಜದ ಉನ್ನತಿಯನ್ನು
                                ಬಯಸುವ ದಿವ್ಯ ಕಾರ್ಯಗಳಲ್ಲಿ ಪ್ರತಿಯೊಬ್ಬರ ಅಳಿಲು ಸೇವೆಯೂ ಅಮೂಲ್ಯ.”
                            </p>
                            <p className="font-display italic text-xl lg:text-2xl text-gold mt-5">
                                “Like a sacred offering in a yajna, even the smallest contribution
                                to such divine work is invaluable.”
                            </p>
                            <p className="text-kannada text-lg text-ink/85 mt-8 leading-relaxed">
                                ನೀವು ನೀಡುವ ಪ್ರತಿಯೊಂದು ಸಣ್ಣ ಕೊಡುಗೆಯೂ ಈ ಪಿರಮಿಡ್ ನಾದಮಂದಿರದ
                                ಒಂದೊಂದು ಇಟ್ಟಿಗೆಯಾಗಲಿದೆ.
                            </p>
                            <p className="font-serif italic text-base lg:text-lg text-ink/80 mt-2 leading-relaxed">
                                Every contribution you offer becomes a brick in this Pyramid Nada Mandira.
                            </p>

                            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                                <a
                                    href="#donate"
                                    data-testid="vision-cta-collaborate"
                                    className="btn-primary inline-flex items-center gap-2"
                                >
                                    <HeartHandshake size={16} />
                                    Collaborate with us
                                </a>
                                <a
                                    href="#donate"
                                    data-testid="vision-cta-donate"
                                    className="btn-ghost-gold inline-flex items-center gap-2"
                                >
                                    <Sparkles size={16} />
                                    Become a Patron
                                </a>
                            </div>

                            <p className="eyebrow text-gold mt-10">
                                · ಸಂಸ್ಕೃತಿ ಮತ್ತು ಅಧ್ಯಾತ್ಮದ ರಕ್ಷಣೆಗಾಗಿ ಕೈಜೋಡಿಸಿ ·
                            </p>
                            <p className="font-display italic text-lg text-maroon mt-1">
                                Join hands to safeguard culture and spirituality.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* DONATE */}
            <section
                id="donate"
                data-testid="vision-donate"
                className="section-pad bg-maroon-900 text-ivory relative overflow-hidden"
            >
                <div
                    className="absolute inset-0 opacity-[0.07] pointer-events-none"
                    style={{
                        backgroundImage:
                            "radial-gradient(rgba(221,183,113,0.7) 1px, transparent 1px)",
                        backgroundSize: "4px 4px",
                    }}
                />
                <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
                    {/* Sacred pyramid hero image for Donate section */}
                    <div className="relative mb-16 overflow-hidden border border-gold/40" data-testid="donate-hero-image">
                        <img
                            src={ASSETS.visionFront}
                            alt="Shri Vishwa Bandhu Pyramid Nadabrahma Mandira — front view of the sanctum with tabla at the threshold"
                            className="w-full h-[360px] lg:h-[460px] object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-maroon-900/95 via-maroon-900/35 to-transparent" />
                        <div className="absolute bottom-0 left-0 right-0 p-8 lg:p-12 text-ivory">
                            <div className="eyebrow text-gold-300">· ನಾದಬ್ರಹ್ಮ ಮಂದಿರ · Nadabrahma Mandira ·</div>
                            <h3 className="font-display text-3xl lg:text-5xl text-ivory mt-3 leading-tight max-w-3xl">
                                Be the architect of a
                                <span className="italic text-gold-300"> sacred silence.</span>
                            </h3>
                            <p className="text-kannada text-base lg:text-lg text-gold-300 mt-3 max-w-3xl leading-relaxed">
                                ಪ್ರತಿಯೊಂದು ಸಣ್ಣ ಕೊಡುಗೆಯೂ ಈ ಪಿರಮಿಡ್ ನಾದಮಂದಿರದ ಒಂದೊಂದು ಇಟ್ಟಿಗೆಯಾಗಲಿದೆ.
                            </p>
                        </div>
                    </div>

                    <div className="text-center mb-14">
                        <div className="eyebrow text-gold-300">· Donate · ದೇಣಿಗೆ · Become a Patron ·</div>
                        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-ivory mt-4 leading-tight">
                            Lay a brick of the
                            <span className="italic text-gold-300"> Nada Mandira.</span>
                        </h2>
                        <p className="text-kannada text-xl text-gold-300 mt-4">
                            ನೀವು ನೀಡುವ ಪ್ರತಿಯೊಂದು ಸಣ್ಣ ಕೊಡುಗೆಯೂ ಈ ಪಿರಮಿಡ್ ನಾದಮಂದಿರದ ಒಂದೊಂದು ಇಟ್ಟಿಗೆಯಾಗಲಿದೆ.
                        </p>
                        <p className="font-serif italic text-lg lg:text-xl text-ivory/85 max-w-3xl mx-auto mt-3 leading-relaxed">
                            Every contribution you offer becomes a brick in this Pyramid Nada Mandira —
                            and a part of the silence of the next generation.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-stretch">
                        {/* QR Code card */}
                        <div
                            className="lg:col-span-5 bg-ivory text-ink p-8 lg:p-10 border border-gold/40 text-center flex flex-col items-center"
                            data-testid="donate-qr-card"
                        >
                            <div className="eyebrow text-gold">· Scan to Donate · UPI ·</div>
                            <div className="font-display text-2xl text-maroon mt-3">
                                Scan with any UPI app
                            </div>
                            <p className="font-serif text-ink/70 text-sm mt-2">
                                Google Pay · PhonePe · Paytm · BHIM · Any UPI
                            </p>

                            <div className="relative mt-7 p-5 bg-white border-2 border-gold/60">
                                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-ivory px-3">
                                    <QrCode size={20} className="text-maroon" />
                                </div>
                                <img
                                    src={`https://api.qrserver.com/v1/create-qr-code/?size=320x320&margin=0&color=5A111F&data=${encodeURIComponent(
                                        `upi://pay?pa=${GURUKULA.upiId}&pn=${encodeURIComponent(
                                            GURUKULA.upiPayeeName
                                        )}&cu=INR&tn=Gurukula+Donation`
                                    )}`}
                                    alt="UPI donation QR code for Shri Vishwa Bandhu Sangeetha Gurukula"
                                    data-testid="donate-qr-image"
                                    className="w-64 h-64 object-contain"
                                />
                            </div>

                            <div className="mt-6 w-full">
                                <div className="eyebrow text-ink/60">UPI ID</div>
                                <button
                                    type="button"
                                    data-testid="donate-copy-upi"
                                    onClick={() => {
                                        navigator.clipboard?.writeText(GURUKULA.upiId);
                                        toast.success("UPI ID copied. Thank you for your support.");
                                    }}
                                    className="mt-2 inline-flex items-center gap-2 font-sans font-medium text-xl tabular-nums tracking-[0.05em] text-maroon hover:text-gold transition-colors"
                                >
                                    {GURUKULA.upiId}
                                    <Copy size={16} />
                                </button>
                            </div>

                            <a
                                href={`upi://pay?pa=${GURUKULA.upiId}&pn=${encodeURIComponent(
                                    GURUKULA.upiPayeeName
                                )}&cu=INR&tn=Gurukula+Donation`}
                                data-testid="donate-upi-link"
                                className="btn-primary mt-7 inline-flex items-center gap-2"
                            >
                                <HeartHandshake size={16} />
                                Pay via UPI
                            </a>
                        </div>

                        {/* Patron tiers + bank/contact */}
                        <div className="lg:col-span-7 space-y-6">
                            <div className="bg-maroon border border-gold/30 p-8" data-testid="donate-letter">
                                <div className="eyebrow text-gold-300">· ಆತ್ಮೀಯ ಬಂಧುಗಳೇ · A Personal Note ·</div>
                                <p className="text-kannada text-lg text-ivory/95 mt-4 leading-relaxed">
                                    “ಸಂಸ್ಕೃತಿ ಮತ್ತು ಅಧ್ಯಾತ್ಮದ ರಕ್ಷಣೆಗಾಗಿ ಕೈಜೋಡಿಸಿ.”
                                </p>
                                <p className="font-display italic text-xl text-gold-300 mt-2 leading-snug">
                                    “Join hands to safeguard culture and spirituality.”
                                </p>
                                <p className="font-serif text-ivory/85 mt-5 leading-relaxed">
                                    Your support is not a transaction — it is a samidha, a sacred offering
                                    in the yajna of music. Every rupee carries the prayer of a future
                                    seeker who will sit, breathe, and listen inside this Mandira.
                                </p>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                                {[
                                    { tier: "Sankalpa", amt: "₹ 501", note: "An offering of intention" },
                                    { tier: "Samidha", amt: "₹ 2,501", note: "One sacred brick laid" },
                                    { tier: "Saptaswara", amt: "₹ 11,001", note: "Seven notes engraved forever" },
                                ].map((t) => (
                                    <div
                                        key={t.tier}
                                        data-testid={`donate-tier-${t.tier.toLowerCase()}`}
                                        className="border border-gold/30 bg-maroon/50 p-5 text-center"
                                    >
                                        <div className="eyebrow text-gold-300">{t.tier}</div>
                                        <div className="font-display text-3xl text-ivory mt-2 tabular-nums">
                                            {t.amt}
                                        </div>
                                        <div className="font-serif italic text-ivory/85 text-base lg:text-lg mt-2">
                                            {t.note}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="bg-maroon border border-gold/30 p-8">
                                <div className="eyebrow text-gold-300">· Talk to the Gurukula ·</div>
                                <p className="font-serif text-ivory/85 mt-4 leading-relaxed">
                                    For larger contributions, NRI donations, or to discuss patronage
                                    and naming opportunities for the Mandira, please reach out directly:
                                </p>
                                <div className="mt-5 flex flex-wrap items-center gap-5">
                                    <a
                                        href={`tel:${GURUKULA.phone}`}
                                        data-testid="donate-phone"
                                        className="inline-flex items-center gap-3 font-sans font-medium text-2xl lg:text-3xl tabular-nums tracking-[0.08em] text-ivory hover:text-gold-300 transition-colors"
                                    >
                                        <Phone size={20} className="text-gold-300" />
                                        {GURUKULA.phone}
                                    </a>
                                    <Link
                                        to="/#contact"
                                        data-testid="donate-write-link"
                                        className="inline-block bg-gold text-maroon font-sans text-[12px] tracking-[0.28em] uppercase px-7 py-3 hover:bg-gold-300 transition-colors"
                                    >
                                        Write to us
                                    </Link>
                                </div>
                                <p className="font-serif italic text-ivory/60 text-xs mt-6">
                                    Note: a formal 80G receipt mechanism for tax exemption is in the
                                    process of being set up.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* WAYS TO HELP */}
                    <div className="mt-20" data-testid="donate-ways">
                        <div className="text-center mb-12">
                            <div className="eyebrow text-gold-300">· ನೀವು ಹೇಗೆ ಸಹಕರಿಸಬಹುದು · How You Can Help ·</div>
                            <h3 className="font-display text-3xl sm:text-4xl text-ivory mt-3 leading-tight">
                                Four ways to walk
                                <span className="italic text-gold-300"> beside us.</span>
                            </h3>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {[
                                {
                                    Icon: MapPin,
                                    titleKn: "ಸ್ಥಳಾವಕಾಶ / ಜಾಗದ ಮಹಾದಾನ",
                                    titleEn: "Land Donation / Sponsorship",
                                    kn: "ಈ ಬೃಹತ್ ಆಧ್ಯಾತ್ಮಿಕ ಮತ್ತು ನಾದಯೋಗ ಕೇಂದ್ರದ ನಿರ್ಮಾಣಕ್ಕೆ ಕನಿಷ್ಠ 5 ಎಕರೆ ಜಾಗದ ಅಗತ್ಯವಿದೆ. ಭೂದಾನ ಮಾಡಲು ಇಚ್ಛಿಸುವ ಉದಾರಿಗಳು ನಮ್ಮೊಂದಿಗೆ ಕೈಜೋಡಿಸಬಹುದು.",
                                    en: "A minimum of 5 acres is required for this spiritual and Nadayoga centre. Patrons willing to gift land are warmly invited to join hands with us.",
                                },
                                {
                                    Icon: BookOpen,
                                    titleKn: "ಜ್ಞಾನ ಮತ್ತು ಕಲಾ ಸೇವೆ",
                                    titleEn: "Knowledge & Art Service",
                                    kn: "ಸಂಗೀತಜ್ಞರು, ಧ್ಯಾನ ಶಿಕ್ಷಕರು ಮಾರ್ಗದರ್ಶನ ನೀಡುವ ಮೂಲಕ ಹಾಗೂ ಶಿಬಿರಗಳನ್ನು ನಡೆಸಿಕೊಡುವ ಮೂಲಕ ಸಹಕರಿಸಬಹುದು.",
                                    en: "Musicians and meditation teachers can offer guidance, host workshops, and lead retreats with us.",
                                },
                                {
                                    Icon: Hammer,
                                    titleKn: "ಕಟ್ಟಡ ಸಾಮಗ್ರಿ / ವಸ್ತು ರೂಪದ ನೆರವು",
                                    titleEn: "Building Material / In-kind Support",
                                    kn: "ಪಿರಮಿಡ್ ನಿರ್ಮಾಣಕ್ಕೆ ಅಗತ್ಯವಿರುವ ವಿವಿಧ ವಸ್ತುಗಳು ಅಥವಾ ನಿರ್ಮಾಣ ಸಾಮಗ್ರಿಗಳನ್ನು ಪ್ರಾಯೋಜಿಸುವ ಮೂಲಕ.",
                                    en: "Sponsor stone, timber, acoustic materials, or other essentials required for the pyramid's construction.",
                                },
                                {
                                    Icon: Banknote,
                                    titleKn: "ಹಣಕಾಸಿನ ನೆರವು",
                                    titleEn: "Financial Donations",
                                    kn: "ನಿಮ್ಮ ಕೈಲಾದ ಆರ್ಥಿಕ ಸಹಾಯವನ್ನು ನೇರವಾಗಿ ನಮ್ಮ ಗುರುಕುಲದ ಅಧಿಕೃತ ಟ್ರಸ್ಟ್ ಖಾತೆಗೆ ವರ್ಗಾಯಿಸುವ ಮೂಲಕ.",
                                    en: "Transfer your contribution — small or large — directly to the Gurukula's registered Trust account.",
                                },
                            ].map((w, i) => {
                                const Icon = w.Icon;
                                return (
                                    <div
                                        key={w.titleEn}
                                        data-testid={`donate-way-${i}`}
                                        className="border border-gold/30 bg-maroon/40 p-7"
                                    >
                                        <div className="flex items-center justify-between mb-5">
                                            <div className="w-12 h-12 flex items-center justify-center bg-ivory text-maroon">
                                                <Icon size={20} />
                                            </div>
                                            <span className="font-display italic text-gold-300 text-3xl">
                                                {String(i + 1).padStart(2, "0")}
                                            </span>
                                        </div>
                                        <h4 className="text-kannada text-xl text-ivory font-semibold leading-tight">
                                            {w.titleKn}
                                        </h4>
                                        <p className="font-display italic text-xl text-gold-300 mt-1">
                                            {w.titleEn}
                                        </p>
                                        <p className="text-kannada text-lg text-ivory/90 mt-5 leading-relaxed">
                                            {w.kn}
                                        </p>
                                        <p className="font-serif italic text-ivory/85 text-lg mt-3 leading-relaxed">
                                            {w.en}
                                        </p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* BANK DETAILS */}
                    <div className="mt-20" data-testid="donate-bank-details">
                        <div className="text-center mb-10">
                            <div className="eyebrow text-gold-300">· ಬ್ಯಾಂಕ್ ಖಾತೆಯ ವಿವರಗಳು · Bank Details ·</div>
                            <h3 className="font-display text-3xl sm:text-4xl text-ivory mt-3 leading-tight">
                                For Direct Bank Transfer
                            </h3>
                            <p className="text-kannada text-base text-gold-300 mt-3">
                                ನಮ್ಮ ಗುರುಕುಲದ ಅಧಿಕೃತ ಟ್ರಸ್ಟ್ ಖಾತೆಗೆ ನೇರವಾಗಿ ವರ್ಗಾಯಿಸಿ.
                            </p>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                            <div className="lg:col-span-7 bg-ivory text-ink p-8 lg:p-10 border border-gold/40">
                                <div className="flex items-center gap-3 mb-6">
                                    <div className="w-12 h-12 flex items-center justify-center bg-maroon text-gold-300">
                                        <Building2 size={20} />
                                    </div>
                                    <div className="font-display text-2xl text-maroon leading-tight">
                                        Canara Bank
                                        <span className="block font-serif italic text-base text-ink/70">
                                            Chandra Layout Branch, Bangalore
                                        </span>
                                    </div>
                                </div>

                                <dl className="divide-y divide-gold-100">
                                    {[
                                        { k: "Account Name", v: GURUKULA.bank.name, mono: false },
                                        { k: "Bank Name", v: GURUKULA.bank.bankName, mono: false },
                                        { k: "Account Number", v: GURUKULA.bank.account, mono: true, testid: "bank-account" },
                                        { k: "IFSC Code", v: GURUKULA.bank.ifsc, mono: true, testid: "bank-ifsc" },
                                        { k: "Branch", v: GURUKULA.bank.branch, mono: false },
                                    ].map((row) => (
                                        <div
                                            key={row.k}
                                            className="py-3 grid grid-cols-12 gap-3 items-center"
                                        >
                                            <dt className="col-span-12 sm:col-span-5 eyebrow text-ink/60">
                                                {row.k}
                                            </dt>
                                            <dd
                                                className={
                                                    "col-span-12 sm:col-span-7 text-maroon " +
                                                    (row.mono
                                                        ? "font-sans font-medium text-lg tabular-nums tracking-[0.06em]"
                                                        : "font-display text-lg")
                                                }
                                                data-testid={row.testid}
                                            >
                                                {row.v}
                                                {row.mono && (
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            navigator.clipboard?.writeText(row.v);
                                                            toast.success(`${row.k} copied.`);
                                                        }}
                                                        className="ml-3 align-middle text-gold hover:text-maroon transition-colors"
                                                        aria-label={`Copy ${row.k}`}
                                                    >
                                                        <Copy size={14} />
                                                    </button>
                                                )}
                                            </dd>
                                        </div>
                                    ))}
                                </dl>

                                {GURUKULA.bank.passbookPdf && (
                                    <a
                                        href={GURUKULA.bank.passbookPdf}
                                        target="_blank"
                                        rel="noreferrer"
                                        data-testid="donate-passbook-pdf"
                                        className="mt-6 inline-flex items-center gap-2 text-[11px] font-sans tracking-[0.24em] uppercase text-maroon hover:text-gold transition-colors border-b border-gold/40 pb-1"
                                    >
                                        ↓ Download official Canara Bank passbook (PDF)
                                    </a>
                                )}
                            </div>

                            <div className="lg:col-span-5 space-y-5">
                                <a
                                    href={`tel:${GURUKULA.upiNumber}`}
                                    data-testid="donate-gpay-number"
                                    className="block bg-maroon border border-gold/30 p-7 hover:border-gold-300 transition-colors"
                                >
                                    <div className="eyebrow text-gold-300">· GPay / PhonePe ·</div>
                                    <div className="font-sans font-medium text-3xl lg:text-4xl tabular-nums tracking-[0.08em] text-ivory mt-3">
                                        {GURUKULA.upiNumber}
                                    </div>
                                    <div className="font-serif italic text-ivory/85 text-base lg:text-lg mt-3">
                                        Pay directly via any UPI app to this number.
                                    </div>
                                </a>

                                <a
                                    href={`mailto:${GURUKULA.donationEmail}`}
                                    data-testid="donate-email"
                                    className="block bg-maroon border border-gold/30 p-7 hover:border-gold-300 transition-colors"
                                >
                                    <div className="eyebrow text-gold-300 flex items-center gap-2">
                                        <Mail size={12} /> Email
                                    </div>
                                    <div className="font-display text-2xl text-ivory mt-3 break-all">
                                        {GURUKULA.donationEmail}
                                    </div>
                                    <div className="font-serif italic text-ivory/85 text-base lg:text-lg mt-3">
                                        Write to us for patronage, in-kind support, or 80G inquiries.
                                    </div>
                                </a>
                            </div>
                        </div>

                        {/* Receipt instructions */}
                        <div
                            className="mt-8 border border-gold/40 bg-maroon/40 p-6 lg:p-8 flex items-start gap-5"
                            data-testid="donate-receipt-note"
                        >
                            <div className="w-12 h-12 shrink-0 flex items-center justify-center bg-gold text-maroon">
                                <MessageCircle size={22} />
                            </div>
                            <div>
                                <div className="eyebrow text-gold-300">· ಗಮನಿಸಿ · After You Donate ·</div>
                                <p className="text-kannada text-base text-ivory/95 mt-3 leading-relaxed">
                                    ದೇಣಿಗೆ ನೀಡಿದ ನಂತರ ದಯವಿಟ್ಟು ಅದರ ರಸೀದಿ ಅಥವಾ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಅನ್ನು ನಮ್ಮ
                                    ವಾಟ್ಸಾಪ್ ಸಂಖ್ಯೆಗೆ{" "}
                                    <a
                                        href={`https://wa.me/91${GURUKULA.whatsapp}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-gold-300 font-sans font-medium tabular-nums tracking-[0.06em] hover:text-ivory"
                                    >
                                        {GURUKULA.whatsapp}
                                    </a>{" "}
                                    ಕಳುಹಿಸಿಕೊಡಿ. ನಾವು ನಿಮಗೆ ಗುರುಕುಲದ ವತಿಯಿಂದ ಕೃತಜ್ಞತಾ ಪತ್ರವನ್ನು
                                    ಕಳುಹಿಸುತ್ತೇವೆ.
                                </p>
                                <p className="font-serif italic text-ivory/85 text-base lg:text-lg mt-3 leading-relaxed">
                                    After donating, please send the receipt or screenshot to our
                                    WhatsApp number{" "}
                                    <a
                                        href={`https://wa.me/91${GURUKULA.whatsapp}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-gold-300 not-italic font-sans font-medium tabular-nums tracking-[0.06em] hover:text-ivory"
                                    >
                                        {GURUKULA.whatsapp}
                                    </a>{" "}
                                    — we will send a letter of gratitude from the Gurukula.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* FOUNDER QUOTE */}
                    <div
                        className="mt-20 max-w-4xl mx-auto bg-ivory text-ink p-10 lg:p-14 relative"
                        data-testid="donate-founder-quote"
                    >
                        <div className="absolute -top-5 left-10 font-display text-7xl text-gold leading-none">
                            “
                        </div>
                        <p className="text-kannada text-2xl lg:text-3xl text-maroon font-semibold leading-snug mt-3">
                            ನಾದ ಸೇವೆಗಿಂತ ಮಿಗಿಲಾದ ಸೇವೆ ಇಲ್ಲ. ಬನ್ನಿ, ನಾವೆಲ್ಲರೂ ಸೇರಿ ಸಮಾಜಕ್ಕೆ
                            ಸಾತ್ತ್ವಿಕ ಮತ್ತು ನವ ಚೈತನ್ಯದ ಸೃಷ್ಟಿಯನ್ನು ಉಡುಗೊರೆಯಾಗಿ ನೀಡೋಣ.
                        </p>
                        <p className="font-display italic text-xl lg:text-2xl text-gold mt-5 leading-snug">
                            “There is no service higher than the service of Nada. Come, let us together
                            gift society a creation of sattva and new consciousness.”
                        </p>
                        <div className="mt-8 pt-6 border-t border-gold-100 flex items-center gap-4">
                            <img
                                src={ASSETS.founder}
                                alt="Shri Ananya Bhargava Bedur"
                                className="w-14 h-14 rounded-full object-cover ring-1 ring-gold/50"
                            />
                            <div>
                                <div className="font-display text-xl text-maroon">
                                    Shri Ananya Bhargava Bedur
                                </div>
                                <div className="text-kannada text-base text-ink/85">
                                    ಶ್ರೀ ಅನನ್ಯ ಭಾರ್ಗವ ಬೇದೂರು
                                </div>
                                <div className="eyebrow text-gold mt-1">
                                    Founder & Director · ಸಂಸ್ಥಾಪಕರು ಮತ್ತು ನಿರ್ದೇಶಕರು
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* TRANSPARENCY */}
                    <div
                        className="mt-12 max-w-4xl mx-auto border border-gold/30 bg-maroon/40 p-7 lg:p-9 flex items-start gap-5"
                        data-testid="donate-transparency"
                    >
                        <div className="w-12 h-12 shrink-0 flex items-center justify-center bg-gold text-maroon">
                            <ShieldCheck size={22} />
                        </div>
                        <div>
                            <div className="eyebrow text-gold-300">· ಪಾರದರ್ಶಕತೆ · Transparency Commitment ·</div>
                            <p className="text-kannada text-base text-ivory/95 mt-3 leading-relaxed">
                                ನಾವು ಸ್ವೀಕರಿಸುವ ಪ್ರತಿಯೊಂದು ರೂಪಾಯಿಯನ್ನೂ ಈ ಪಿರಮಿಡ್ ಮಂದಿರದ
                                ನಿರ್ಮಾಣಕ್ಕಾಗಿಯೇ ಬಳಸಲಾಗುವುದು ಮತ್ತು ಇದರ ಪ್ರಗತಿಯನ್ನು ಕಾಲಕಾಲಕ್ಕೆ
                                ವೆಬ್‌ಸೈಟ್‌ನಲ್ಲಿ ನವೀಕರಿಸಲಾಗುವುದು.
                            </p>
                            <p className="font-serif italic text-ivory/85 text-base lg:text-lg mt-3 leading-relaxed">
                                Every rupee we receive will be used solely for the construction of
                                this Pyramid Mandira, and its progress will be updated on this
                                website from time to time.
                            </p>
                        </div>
                    </div>

                    <OrnamentalDivider className="mt-16 opacity-70" />
                    <p className="text-center text-kannada text-lg text-gold-300 mt-10">
                        ಯಜ್ಞ ಪ್ರಕ್ರಿಯೆಯಲ್ಲಿ ಸಮಿಧೆಯನ್ನು ಹಾಕುವಂತೆ — ಪ್ರತಿಯೊಬ್ಬರ ಅಳಿಲು ಸೇವೆಯೂ ಅಮೂಲ್ಯ.
                    </p>
                </div>
            </section>

            <Footer />
        </div>
    );
}
